import { createFileRoute } from "@tanstack/react-router";

import { KnowledgeBasePage } from "../components/knowledge/KnowledgeBasePage";

export type KnowledgeSearch = {
  readonly tab?: "profile" | "behavior" | "preferences";
  readonly view?: "memory";
};

export const Route = createFileRoute("/knowledge")({
  validateSearch: (raw: Record<string, unknown>): KnowledgeSearch => ({
    ...(raw.tab === "profile" || raw.tab === "behavior" || raw.tab === "preferences"
      ? { tab: raw.tab }
      : {}),
    ...(raw.view === "memory" ? { view: "memory" } : {}),
  }),
  component: KnowledgeBasePage,
});
